module.exports = __webpack_public_path__ + "img/actions-1.png";